import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { DriversPage } from '@/pages/drivers-page'
import type { GetDriversQueryParams } from '@/shared/api'
import { LIMIT_OPTIONS, type LimitType } from '@/shared/model'

type DriversSearch = Omit<GetDriversQueryParams, 'limit' | 'offset' | 'drivee_city_id'> & {
    limit: LimitType
    page?: number
}

export const Route = createFileRoute('/_dashboard/drivers')({
    onEnter: () => {
        document.title = 'Taxoparkee - Водители'
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager, ROLES.recruiter])) {
            throw redirect({
                to: '/recruitment',
                search: { page: 1 },
            })
        }
    },
    component: DriversPage,
    validateSearch: (search: Record<string, unknown>): DriversSearch => {
        return {
            limit: (search.limit as number) ?? LIMIT_OPTIONS[0],
            page: (search.page as number) ?? 1,
            active_last_45_days: search.active_last_45_days as boolean,
            drivee_id: search.drivee_id === '' ? undefined : (search.drivee_id as number),
            no_orders_14_to_20_days: search.no_orders_14_to_20_days as boolean,
            no_orders_14_to_45_days: search.no_orders_14_to_45_days as boolean,
            no_orders_21_to_30_days: search.no_orders_21_to_30_days as boolean,
            no_orders_31_to_45_days: search.no_orders_31_to_45_days as boolean,
            phone: search.phone === '' ? undefined : (search.phone as string),
            recruiter_id: search.recruiter_id === '' ? undefined : (search.recruiter_id as string),
        }
    },
})
